<template>
  <section ref="section" style="width: 100%" :key="sectionKey" @keydown.enter="submitDebounced">
    <div class="inputs-group-box" v-if="processingUnico">
      <h3 class="unicotest-processing-checkCamera">
        Processando...
        <SpinnerButton v-if="processingUnico" />
      </h3>
    </div>
    <!-- GROUPS-->
    <div v-for="(group, g) in fieldGroups" :key="g" v-show="group.enable && groupConditionsMet(group)" v-if="!processingUnico">
      <div class="inputs-group-box" :style="{ '--group-margin': group.margin, '--group-padding': group.padding, '--group-borderRadius': group.borderRadius, background: group.bgColor }">
        <!-- GROUP-->
        <h3 class="group-field-title-placeholder" style="margin-top: 20px; margin-bottom: 3px" v-html="group.title"></h3>
        <div class="inputs-line-container" v-for="(field, k) in group.fields" :key="fieldsKey + k" v-show="field.enable">
          <!-- NON CONDITIONAL -->
          <div class="general-input-container" v-if="!field.conditional">
            <div class="group-field-title-placeholder" v-html="field.placeholder"></div>
            <div class="general-input-wrapper" :id="field.name">
              <ion-icon class="ionicon-icon" :name="field.icon" v-if="field.icon != ''"></ion-icon>
              <!-- GENERAL INPUT -->
              <input
                :ref="field.name"
                :title="field.placeholder"
                v-maska="field.mask"
                :disabled="field.lock"
                v-if="!specializedInputs.includes(field.type) && !field.phone"
                class="general-input"
                :class="{ isLocked: field.lock }"
                :style="field.case"
                :type="field.type"
                :maxlength="field.maxlength"
                @keypress="keypressHandler"
                @input="inputChanged($event, field)"
                @focus="showOSK(field.name)"
                @blur="handleAutocomplete($event, field)"
                v-model="inputValues[field.name]" />
              <!-- CHECKBOX INPUT-->
              <input
                v-if="field.type == 'checkbox'"
                class="general-input is-checkbox"
                :type="field.type"
                @keypress="keypressHandler"
                @input="inputChanged($event, field)"
                @blur="handleAutocomplete($event, field)"
                v-model="inputValues[field.name]" />
              <span v-if="field.type == 'checkbox'" class="checkbox-span" v-html="field.placeholder"></span>
              <!-- SELECT INPUT -->
              <div class="select-and-placeholder-container" v-if="field.type == 'select'">
                <select :title="field.placeholder" class="general-input is-select" required :value="inputValues[field.name] ? inputValues[field.name] : field.default" @change="onSelectChange($event, field)">
                  <option v-for="(option, i) in field.options" :key="i" :value="option">{{ option }}</option>
                </select>
              </div>
              <!-- SEARCHABLE SELECT INPUT -->
              <div class="select-and-placeholder-container" v-if="field.type == 'search_select'">
                <SearchableSelect class="general-input is-select" :placeholder="field.searchPlaceholder ? field.searchPlaceholder : 'buscar...'" :options="conformedSearchableSelectOptions(field.options)" v-model="inputValues[field.name]" />
              </div>
              <!-- MULTISELECT INPUT-->
              <div class="select-and-placeholder-container" v-if="field.type == 'multiselect'">
                <Multiselect
                  placeholder=""
                  selectedLabel="selecionada"
                  selectLabel="selecionar"
                  deselectLabel="remover"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :options="field.options"
                  @input="multiselectChanged($event, field)"
                  v-model="inputValues[field.name]" />
              </div>
              <!-- PHONE INPUT -->
              <vue-tel-input
                :ref="field.name"
                :title="field.placeholder"
                :mode="'international'"
                :enabledFlags="true"
                :preferredCountries="['BR', 'US', 'FR', 'AR']"
                :disabledFetchingCountry="true"
                :enabledCountryCode="false"
                :maxLen="field.maxlength"
                v-if="field.phone"
                class="telephone-input"
                :id="field.name"
                placeholder=""
                @input="inputChanged($event, field)"
                @focus="showOSK(field.name)"
                @blur="handleAutocomplete($event, field)"
                v-model="inputValues[field.name]"></vue-tel-input>
              <!-- IMAGE INPUT -->
              <img class="special-image-input" v-if="field.type == 'image'" :src="field.image" />
            </div>
          </div>
          <!-- CONDITIONAL -->
          <div class="general-input-container" v-if="field.conditional && evaluateConditional(field.conditional)">
            <div class="group-field-title-placeholder" v-html="field.placeholder"></div>
            <div class="general-input-wrapper" :id="field.name">
              <ion-icon class="ionicon-icon" :name="field.icon" v-if="field.icon != ''"></ion-icon>
              <!-- GENERAL INPUT -->
              <input
                :title="field.placeholder"
                v-maska="field.mask"
                :disabled="field.lock"
                v-if="!specializedInputs.includes(field.type) && !field.phone"
                class="general-input"
                :class="{ isLocked: field.lock }"
                :style="field.case"
                :type="field.type"
                :maxlength="field.maxlength"
                @keypress="keypressHandler($event, field)"
                v-model="inputValues[field.name]"
                @input="inputChanged($event, field)"
                @blur="handleAutocomplete($event, field)" />
              <!-- CHECKBOX INPUT-->
              <input v-if="field.type == 'checkbox'" class="general-input is-checkbox" :type="field.type" @keypress="keypressHandler" v-model="inputValues[field.name]" />
              <span v-if="field.type == 'checkbox'" class="checkbox-span" v-html="field.placeholder"></span>
              <!-- SELECT INPUT -->
              <div class="select-and-placeholder-container" v-if="field.type == 'select'">
                <select :title="field.placeholder" class="general-input is-select" required :value="inputValues[field.name] ? inputValues[field.name] : field.default" @change="onSelectChange($event, field)">
                  <option v-for="(option, i) in field.options" :key="i" :value="option">{{ option }}</option>
                </select>
              </div>
              <!-- SEARCHABLE SELECT INPUT -->
              <div class="select-and-placeholder-container" v-if="field.type == 'search_select'">
                <SearchableSelect class="general-input is-select" :placeholder="field.searchPlaceholder ? field.searchPlaceholder : 'buscar...'" :options="conformedSearchableSelectOptions(field.options)" v-model="inputValues[field.name]" />
              </div>
              <!-- MULTISELECT INPUT-->
              <div class="select-and-placeholder-container" v-if="field.type == 'multiselect'">
                <Multiselect
                  placeholder=""
                  selectedLabel="selecionada"
                  selectLabel="selecionar"
                  deselectLabel="remover"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="true"
                  :options="field.options"
                  @input="multiselectChanged($event, field)"
                  v-model="inputValues[field.name]" />
              </div>
              <!-- PHONE INPUT -->
              <vue-tel-input
                :title="field.placeholder"
                :mode="'international'"
                :enabledFlags="true"
                :preferredCountries="['BR', 'US', 'FR', 'AR']"
                :disabledFetchingCountry="true"
                :enabledCountryCode="false"
                v-if="field.phone"
                :maxLen="field.maxlength"
                class="telephone-input"
                :id="field.name"
                placeholder=""
                @blur="handleAutocomplete($event, field)"
                v-model="inputValues[field.name]"></vue-tel-input>
              <!-- IMAGE INPUT -->
              <img class="special-image-input" v-if="field.type == 'image'" :src="field.image" />
            </div>
          </div>

          <!-- SIBLINGS -->
          <div style="display: contents" v-for="sibling in field.siblings" :key="sibling.name">
            <!-- NON CONDITIONAL SIBLINGS -->
            <div class="general-input-container" v-if="field.siblings && !sibling.conditional" :style="{ visibility: sibling.type == 'hidden_block' ? 'hidden' : 'visible', height: sibling.type == 'hidden_block' ? '0' : 'inherit' }">
              <div class="group-field-title-placeholder" v-html="sibling.placeholder"></div>
              <div class="general-input-wrapper" :id="sibling.name">
                <ion-icon class="ionicon-icon" :name="sibling.icon" v-if="sibling.icon != ''"></ion-icon>
                <!-- GENERAL INPUT -->
                <input
                  :title="sibling.placeholder"
                  v-maska="sibling.mask"
                  :disabled="sibling.lock"
                  v-if="!specializedInputs.includes(sibling.type) && !sibling.phone"
                  class="general-input"
                  :class="{ isLocked: sibling.lock }"
                  :style="sibling.case"
                  :type="sibling.type"
                  :maxlength="sibling.maxlength"
                  @keypress="keypressHandler"
                  @input="inputChanged($event, sibling)"
                  v-model="inputValues[sibling.name]"
                  @blur="handleAutocomplete($event, sibling)" />
                <!-- CHECKBOX INPUT-->
                <input v-if="sibling.type == 'checkbox'" class="general-input is-checkbox" :type="sibling.type" :ref="sibling.ref" @keypress="keypressHandler" v-model="inputValues[sibling.name]" />
                <span v-if="sibling.type == 'checkbox'" class="checkbox-span" v-html="sibling.placeholder"></span>
                <!-- SELECT INPUT -->
                <div class="select-and-placeholder-container" v-if="sibling.type == 'select'">
                  <select :title="sibling.placeholder" class="general-input is-select" required :value="inputValues[sibling.name] ? inputValues[sibling.name] : sibling.default" @change="onSelectChange($event, sibling)">
                    <option v-for="(option, i) in sibling.options" :key="i" :value="option">{{ option }}</option>
                  </select>
                </div>
                <!-- SEARCHABLE SELECT INPUT -->
                <div class="select-and-placeholder-container" v-if="sibling.type == 'search_select'">
                  <SearchableSelect
                    class="general-input is-select"
                    :placeholder="sibling.searchPlaceholder ? sibling.searchPlaceholder : 'buscar...'"
                    :options="conformedSearchableSelectOptions(sibling.options)"
                    v-model="inputValues[sibling.name]" />
                </div>
                <!-- MULTISELECT INPUT-->
                <div class="select-and-placeholder-container" v-if="sibling.type == 'multiselect'">
                  <Multiselect
                    placeholder=""
                    selectedLabel="selecionada"
                    selectLabel="selecionar"
                    deselectLabel="remover"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="true"
                    :options="sibling.options"
                    @input="multiselectChanged($event, sibling)"
                    v-model="inputValues[sibling.name]" />
                </div>
                <!-- PHONE INPUT -->
                <vue-tel-input
                  :title="sibling.placeholder"
                  :mode="'international'"
                  :enabledFlags="true"
                  :preferredCountries="['BR', 'US', 'FR', 'AR']"
                  :disabledFetchingCountry="true"
                  :enabledCountryCode="false"
                  v-if="sibling.phone"
                  :maxLen="sibling.maxlength"
                  class="telephone-input"
                  :id="sibling.name"
                  placeholder=""
                  @blur="handleAutocomplete($event, sibling)"
                  v-model="inputValues[sibling.name]"></vue-tel-input>
                <!-- IMAGE INPUT -->
                <img class="special-image-input" v-if="sibling.type == 'image'" :src="sibling.image" />
              </div>
            </div>
            <!-- CONDITIONAL SIBLINGS -->
            <div
              class="general-input-container"
              v-if="field.siblings && sibling.conditional && evaluateConditional(sibling.conditional)"
              :style="{ visibility: sibling.type == 'hidden_block' ? 'hidden' : 'visible', height: sibling.type == 'hidden_block' ? '0' : 'inherit' }">
              <div class="group-field-title-placeholder" v-html="sibling.placeholder"></div>
              <div class="general-input-wrapper" :id="sibling.name">
                <ion-icon class="ionicon-icon" :name="sibling.icon" v-if="sibling.icon != ''"></ion-icon>
                <!-- GENERAL INPUT -->
                <input
                  :title="sibling.placeholder"
                  v-maska="sibling.mask"
                  :disabled="sibling.lock"
                  v-if="!specializedInputs.includes(sibling.type) && !sibling.phone"
                  class="general-input"
                  :class="{ isLocked: sibling.lock }"
                  :style="sibling.case"
                  :type="sibling.type"
                  :maxlength="sibling.maxlength"
                  @keypress="keypressHandler"
                  @input="inputChanged($event, sibling)"
                  v-model="inputValues[sibling.name]"
                  @blur="handleAutocomplete($event, sibling)" />
                <!-- CHECKBOX INPUT-->
                <input v-if="sibling.type == 'checkbox'" class="general-input is-checkbox" :type="sibling.type" :ref="sibling.ref" @keypress="keypressHandler" v-model="inputValues[sibling.name]" />
                <span v-if="sibling.type == 'checkbox'" class="checkbox-span" v-html="sibling.placeholder"></span>
                <!-- SELECT INPUT -->
                <div class="select-and-placeholder-container" v-if="sibling.type == 'select'">
                  <select :title="sibling.placeholder" class="general-input is-select" required :value="inputValues[sibling.name] ? inputValues[sibling.name] : sibling.default" @change="onSelectChange($event, sibling)">
                    <option v-for="(option, i) in sibling.options" :key="i" :value="option">{{ option }}</option>
                  </select>
                </div>
                <!-- SEARCHABLE SELECT INPUT -->
                <div class="select-and-placeholder-container" v-if="sibling.type == 'search_select'">
                  <SearchableSelect
                    class="general-input is-select"
                    :placeholder="sibling.searchPlaceholder ? sibling.searchPlaceholder : 'buscar...'"
                    :options="conformedSearchableSelectOptions(sibling.options)"
                    v-model="inputValues[sibling.name]" />
                </div>
                <!-- MULTISELECT INPUT-->
                <div class="select-and-placeholder-container" v-if="sibling.type == 'multiselect'">
                  <Multiselect
                    placeholder=""
                    selectedLabel="selecionada"
                    selectLabel="selecionar"
                    deselectLabel="remover"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="true"
                    :options="sibling.options"
                    @input="multiselectChanged($event, sibling)"
                    v-model="inputValues[sibling.name]" />
                </div>
                <!-- PHONE INPUT -->
                <vue-tel-input
                  :title="sibling.placeholder"
                  :mode="'international'"
                  :enabledFlags="true"
                  :preferredCountries="['BR', 'US', 'FR', 'AR']"
                  :disabledFetchingCountry="true"
                  :enabledCountryCode="false"
                  v-if="sibling.phone"
                  :maxLen="sibling.maxlength"
                  class="telephone-input"
                  :id="sibling.name"
                  placeholder=""
                  @blur="handleAutocomplete($event, sibling)"
                  v-model="inputValues[sibling.name]"></vue-tel-input>
                <!-- IMAGE INPUT -->
                <img class="special-image-input" v-if="sibling.type == 'image'" :src="sibling.image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- TERMS -->
    <div :class="{ 'bottom-terms': !shakeAgree, 'bottom-terms shakeAnimation': shakeAgree }">
      <input type="checkbox" style="cursor: pointer" v-model="agree" />
      &nbsp;
      <span class="register-term-text" v-html="accessConfig.registerView.agreeText"></span>
    </div>
    <div :id="term.name" class="register-term" v-for="(term, t) in terms" :key="'term' + t" v-show="term.enable">
      <input type="checkbox" v-model="inputValues[term.name]" v-if="term.type === 'checkbox'" />
      <input :type="term.type" v-model="inputValues[term.name]" v-else />
      &nbsp;
      <span class="register-term-text" v-html="term.placeholder"></span>
      <a class="register-term-text" :href="term.link" target="_blank" v-if="term.link"><i class="fas fa-external-link-alt" style="font-size: 0.9rem; opacity: 0.7"></i></a>
    </div>

    <!-- UNICO CHECK -->
    <!-- <div class="unicotest-frame-checkCamera" v-if="unicoCheck"> -->
    <div v-if="unicoCheck">
      <!-- <UnicoCheckCamera @data="getImage" @error="treatError" /> -->
    </div>
    <!-- RECAPTCHA -->
    <!-- <button class="btn-alt" @click.prevent="validateRecaptcha">get captcha token</button> -->

    <!-- ACTION BUTTON -->
    <button class="enter-and-send-btn" :class="{ 'send-btn-disabled': showButtonSpinner }" :disabled="showButtonSpinner" @click.prevent="submitDebounced">
      {{ accessConfig.registerView.buttonText }}
      <SpinnerButton style="position: relative; border-top: 4px solid red" v-if="showButtonSpinner" />
    </button>

    <!-- ONSCREEN KEYBOARD -->
    <div style="pointer-events: none; position: fixed; inset: 25% 0 0 0; display: flex; align-content: stretch; align-items: center; width: 100%; justify-content: center" v-if="showOnScreenSKeyboard">
      <OSK :key="oskKey" :layout="oskLayout" :selectedInput="selectedInput" :storedTop="oskStoredTop" :storedLeft="oskStoredLeft" @dragstop="oskDragStopped" @hide="hideOSK" />
    </div>
    <div v-if="showSpinner" style="position: fixed; background: #20202060; width: 100vw; height: 100dvh; top: 0; left: 0">
      <div class="lds-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </section>
</template>

<script>
// Vue.directive("uppercase", {
//     update: function (el) {
//         el.value = el.value.toUpperCase()
//     }
// });

import api from '@/services/api';
import encrypt from '@/services/encrypt';
import { VueTelInput } from 'vue-tel-input';
import { maska } from 'maska';
import redirect from '@/services/redirect';
import OSK from '@/components/general/OSK';
import Multiselect from 'vue-multiselect';
import { ModelSelect } from 'vue-search-select';
import 'vue-search-select/dist/VueSearchSelect.css';
import SpinnerButton from '@/components/ui/SpinnerButton.vue';
// import UnicoCheckCamera from '@/components/general/UnicoCheckCamera.vue';

export default {
  name: 'FormInputs',
  props: {
    accessConfig: {
      type: Object,
      default: function () {
        // fallback to multilanguage or default config from store if not provided
        const template = this && this.$store && this.$store.state.template;
        if (template) {
          const userLanguage = this.$store.state.user.language ? this.$store.state.user.language.toLowerCase() : 'pt';
          if (template.multilanguagesConfig && template.accessConfig[`accessConfig_${userLanguage}`]) {
            return template.accessConfig[`accessConfig_${userLanguage}`];
          }
          return template.accessConfig;
        }
        return {};
      },
    },
    fieldGroups: Array,
    user_id: String,
    autoLogin: Boolean,
  },
  components: {
    VueTelInput,
    OSK,
    Multiselect,
    SearchableSelect: ModelSelect,
    SpinnerButton,
    // UnicoCheckCamera,
  },
  directives: { maska },
  data() {
    return {
      sectionKey: '0',
      oskKey: '0',
      A__endings: null,
      fieldsKey: 0,
      agreedTerms: { truthfulness_declaration: true },
      agree: true,
      shakeAgree: false,
      inputValues: { name: '', email: '', company: '', role: '', cep: '', state_code: '', country_code: '', opt_in: true },
      collectedFields: [],
      collectedValues: [],
      collectedInputsAndValues: {},
      event_user_role: null,
      event_user_role_id: '6af978f0-96ed-11e8-bb38-37f5ae311cf6',
      name: '',
      email: '',
      accessLevels: [],
      panelColor: 'transparent',
      requiredFields: [],
      defaultFields: [
        'email',
        'password_confirm',
        'name',
        'nickname',
        'about_me',
        'image',
        'gender',
        'date_of_birth',
        'telephone',
        'cep',
        'street',
        'number',
        'complement',
        'neighborhood',
        'city_id',
        'state_code',
        'country_code',
        'language_code',
        'timezone',
        'opt_in',
        'cpf',
        'company',
        'role',
      ],
      categoryEnabled: false,
      showSpinner: false,
      userLeads: null,
      showOnScreenSKeyboard: false,
      selectedInput: null,
      oskLayout: 'default_compact',
      oskStoredTop: 0,
      oskStoredLeft: 0,
      terms: [],
      specializedInputs: ['checkbox', 'image', 'select', 'multiselect', 'search_select'],
      debounce: false,
      unicoCheck: false,
      showButtonSpinner: false,
      processingUnico: false,
    };
  },
  computed: {
    allFields() {
      let fields = [];
      this.fieldGroups.map((group) => {
        fields = [...fields, ...group.fields];
        group.fields.map((field) => {
          if (field.siblings) {
            fields = [...fields, ...field.siblings];
          }
        });
      });
      return fields;
    },
    requiredTerms() {
      return this.terms.filter((field) => field.required && field.enable);
    },
  },
  methods: {
    evaluateRequiredFields() {
      // this.requiredFields = [];
      this.fieldGroups.map((group) => {
        group.fields.map((field) => {
          if (field.enable && field.required && this.evaluateConditional(field.conditional)) this.requiredFields.push(field.name);
          field.siblings?.map((sibling) => {
            if (sibling.enable && sibling.required && this.evaluateConditional(sibling.conditional)) this.requiredFields.push(sibling.name);
          });
        });
      });
      let set = [...new Set(this.requiredFields)];
      this.requiredFields = set;
    },
    getAccessLevelsData() {
      api
        .get(`/event/${this.$store.state.eventId}/eventUserRole/`)
        .then((response) => {
          // console.log('LEVELS DATA = ', response);
          this.accessLevels = response.data;
          this.accessLevels.sort((a, b) => (a.level > b.level ? 1 : b.level > a.level ? -1 : 0));
          this.accessLevels.map((level) => {
            // console.log(level.description);
            if (level.description.startsWith('{')) {
              level.description = JSON.parse(level.description);
            } else level.description = { target: '', condition: null };
          });
        })
        .catch((err) => {
          this.accessLevels = [];
          console.error(err);
        });
    },
    evaluateConditional(conditionals) {
      if (!conditionals) return true;

      const fieldMap = new Map();
      const fieldGroups = this.accessConfig.registerView.fieldGroups;
      fieldGroups.forEach((group) => {
        group.fields.forEach((field) => {
          fieldMap.set(field.name, field);
        });
      });
      const targetsAndConditions = conditionals.map(({ target, condition, anyData }) => {
        const targetValue = this.inputValues[target];
        const targetField = fieldMap.get(target);
        const targetHasConditionals = targetField && targetField.conditional;
        const conditionOnLower = condition.toLocaleString().toLowerCase().split(',');
        if (anyData) {
          return Boolean(targetValue);
        }

        if (!conditionOnLower.includes(targetValue ? targetValue.toLowerCase() : null)) {
          return false;
        }

        return targetHasConditionals ? this.evaluateConditional(targetField.conditional) : true;
      });
      //return targetsAndConditions.includes(true);

      return targetsAndConditions.every((v) => v === true);
    },

    /*
    evaluateConditional(conditional) {
       if (conditional && conditional[0].anyData && conditional[0].target) {
         let parsedString = this.inputValues[conditional[0].target];
         if (typeof parsedString === 'object') parsedString = JSON.stringify(parsedString);
         return parsedString;
       } else if (conditional) {
         let passesCondition = conditional.every(rule => {
           let parsedString = this.inputValues[rule.target];
           if (typeof this.inputValues[rule.target] === 'object') parsedString = JSON.stringify(parsedString);
           return rule.condition.some(string => string.toLowerCase() === parsedString?.toLowerCase());
         });
         return passesCondition;
       } else {
         return false;
       }
     },
     */
    groupConditionsMet(group) {
      return group.fields.filter((field) => {
        return !field.conditional || this.evaluateConditional(field.conditional);
      }).length;
    },
    collectValues() {
      // console.log('COLLECTVALUES() BEGINS');
      try {
        api
          .get(`event/${this.$store.state.eventId}/user/${this.$store.state.user.id}`)
          .then((response) => {
            // console.log('Inside api.get User= ', response.data);
            if (response.data) {
              this.event_user_role_id = response.data.event_user_role_id;
              // console.log('inputValues BEFORE', JSON.stringify(this.inputValues));
              this.inputValues['email'] = response.data.email;
              this.inputValues['name'] = response.data.name;
              this.inputValues['nickname'] = response.data.nickname;
              this.inputValues['about_me'] = response.data.about_me;
              this.inputValues['image'] = response.data.image;
              this.inputValues['gender'] = response.data.gender;
              this.inputValues['date_of_birth'] = response.data.date_of_birth;
              this.inputValues['telephone'] = response.data.telephone ? response.data.telephone : '';
              this.inputValues['cep'] = response.data.cep;
              this.inputValues['street'] = response.data.street;
              this.inputValues['number'] = response.data.number;
              this.inputValues['complement'] = response.data.complement;
              this.inputValues['neighborhood'] = response.data.neighborhood;
              this.inputValues['city_id'] = response.data.city_id;
              this.inputValues['city'] = response.data.city;
              this.inputValues['state_code'] = response.data.state_code;
              this.inputValues['country_code'] = response.data.country_code;
              this.inputValues['language_code'] = response.data.language_code || this.$store?.state?.user?.language || 'pt';
              this.inputValues['timezone'] = response.data.timezone;
              this.inputValues['opt_in'] = response.data.opt_in;
              this.inputValues['cpf'] = response.data.cpf;
              this.inputValues['company'] = response.data.company;
              this.inputValues['role'] = response.data.role;

              try {
                const otherObj = JSON.parse(response.data.other);
                const otherKeys = Object.keys(otherObj);
                for (let i = 0; i < otherKeys.length; i++) {
                  this.inputValues[otherKeys[i]] = otherObj[otherKeys[i]];
                }
              } catch (error) {
                //console.log('error on other creation')
              }
              this.fieldGroups.map((group) => {
                group.fields.map((field) => {
                  if (field.name == 'city') field.options = [this.inputValues['city'], ...field.options];
                  field.siblings?.map((sibling) => {
                    if (sibling.name == 'city') sibling.options = [this.inputValues['city'], ...field.options];
                  });
                });
              });
              this.lockEmailFieldForRegistered();
            }
          })
          .catch((err) => console.error(err));
      } catch (error) {
        console.error(error);
      }
    },
    collectDefaultValues() {
      this.fieldGroups.map((group) => {
        if (group.enable) {
          group.fields.map((field) => {
            if (field.default) this.inputValues[field.name] = field.default;
            field.siblings?.map((sibling) => {
              if (sibling.default) this.inputValues[sibling.name] = sibling.default;
            });
          });
        }
      });
    },
    lockEmailFieldForRegistered() {
      this.fieldGroups.map((group) => {
        if (group.enable) {
          group.fields.map((field) => {
            if (field.name == 'email' && this.inputValues['email'].includes('@')) field.lock = true;
            field.siblings?.map((sibling) => {
              if (sibling.name == 'email' && this.inputValues['email'].includes('@')) sibling.lock = true;
            });
          });
        }
      });
    },
    onSelectChange(event, field) {
      //console.log('onSelectChange() BEGINS', { event }, { field });
      this.requiredFields = [];
      let fieldGroups = this.accessConfig.registerView.fieldGroups;
      fieldGroups.map((group) => {
        group.fields.map((field) => {
          if (field.enable && field.required && !field.conditional) this.requiredFields.push(field.name);
          field.siblings?.map((sibling) => {
            if (sibling.enable && sibling.required && !sibling.conditional) this.requiredFields.push(sibling.name);
          });
        });
      });
      //console.log('OnSelect');
      if (field.name == 'state_code') {
        //console.log('AQUI');
        this.fieldGroups.map((group) => {
          group.fields.map((field) => {
            if (field.name == 'city') {
              let payload = {
                stateCode: event.target.value,
                languageCode: 'PT-BR',
              };
              api
                .get(`/config/city`, { headers: payload })
                .then((response) => {
                  field.options = [];
                  let options = response.data;
                  options.map((option) => {
                    field.options = [...field.options, option.city];
                  });
                  field.options.push('outra');
                })
                .catch((err) => console.error(err));
            }

            field.siblings?.map((sibling) => {
              if (sibling.name == 'city') {
                let payload = {
                  stateCode: event.target.value,
                  languageCode: 'PT-BR',
                };
                api
                  .get(`/config/city`, { headers: payload })
                  .then((response) => {
                    sibling.options = [];
                    let options = response.data;
                    options.map((option) => {
                      sibling.options = [...sibling.options, option.city];
                    });
                    sibling.options.push('outra');
                  })
                  .catch((err) => console.error(err));
              }
            });
          });
        });
      }
      if (field.type !== 'multiselect') this.inputValues[field.name] = event.target.value;
      this.sectionKey = this.$RNG.randomKey();
      this.assignAccessLevel();

      this.inputChanged(event, field);

      if ((field.type === 'select' || field.type === 'multiselect') && field.queryType) this.handleAutocomplete(event, field);
    },
    multiselectChanged(event, field) {
      this.sectionKey = this.$RNG.randomKey();
      this.onSelectChange(event, field);
    },
    updateInputs() {
      setTimeout(() => {
        let inputKeys = Object.keys(this.inputValues);
        let inputValues = Object.values(this.inputValues);
        for (let i = 0; i < inputKeys.length; i++) {
          this.collectedFields[i] = inputKeys[i];
          this.collectedValues[i] = inputValues[i];
          this.collectedInputsAndValues[inputKeys[i]] = inputValues[i];
        }
      }, 10);
      this.assignAccessLevel();
    },
    assignAccessLevel() {
      if (!this.accessLevels || this.accessLevels.length === 0) return;
      this.accessLevels.map((level) => {
        if (level.description.target) {
          if (level.description.condition === null || !level.description.condition?.length) {
            this.event_user_role = level.event_user_role;
            this.event_user_role_id = level.event_user_role_id;
          } else {
            level.description.condition.map((condition) => {
              if (this.inputValues[level.description.target]?.toLowerCase() == condition.toLowerCase()) {
                this.event_user_role = level.event_user_role;
                this.event_user_role_id = level.event_user_role_id;
              }
            });
          }
        }
      });
    },
    fieldsAreValid() {
      const isCPFRequired = this.requiredFields.includes('cpf');
      const isCPFEntered = this.inputValues['cpf'] && this.inputValues['cpf'] != '';

      if (!isCPFRequired && isCPFEntered) {
        this.requiredFields.push('cpf');
      }

      const isTelephoneRequired = this.requiredFields.includes('telephone');
      const isTelephoneEntered = this.inputValues['telephone'] && this.inputValues['telephone'] != '';

      if (!isTelephoneRequired && isTelephoneEntered) {
        this.requiredFields.push('telephone');
      }

      let validatedInputs = this.requiredFields.map((inputName) => {
        if (!this.isValidInput(inputName)) {
          this.shakeElement(inputName);
          if (inputName == 'password') this.shakeElement('password_confirm');
          if (inputName == 'cpf') {
            this.$modal.show('dialog', {
              title: 'CPF/CNPJ inválido',
              text: 'Por favor confirme a digitação',
              buttons: [
                {
                  title: 'Ok',
                  handler: () => {
                    this.$modal.hide('dialog');
                  },
                },
              ],
            });
          }
        }
        return this.isValidInput(inputName);
      });
      let inputPassesValidation = (isValid) => isValid === true;
      return validatedInputs.every(inputPassesValidation);
    },
    isValidInput(inputName) {
      switch (inputName) {
        case 'name':
          return this.inputValues['name'] !== '' && this.inputValues['name'] !== undefined;

        case 'email':
          let parsedEndings = this.accessConfig.registerView.acceptedEmailDomains?.length ? this.accessConfig.registerView.acceptedEmailDomains.map((item) => item.text) : [''];
          let endings = this.accessConfig.registerView.acceptedEmailDomains?.length ? parsedEndings : [''];
          const isValid = this.endsWithAny(endings, this.inputValues['email']);
          return this.inputValues['email'].includes('@') && isValid;

        case 'email_confirm':
          return this.inputValues['email'] == this.inputValues['email_confirm'];

        case 'password':
          return this.inputValues['password'] != '' && this.inputValues['password'] == this.inputValues['password_confirm'];

        case 'password_confirm':
          return this.inputValues['password'] == this.inputValues['password_confirm'];

        case 'category':
          return this.inputValues['category'] != 'selecione';

        case 'city_id':
          return true;

        case 'city':
          return this.inputValues['city'] && this.inputValues['city'] != 'selecione';

        case 'state_code':
          return this.inputValues['state_code'] != 'selecione';

        case 'code':
          return this.inputValues['code'] ? true : false;

        case 'cpf':
          let cpf = JSON.stringify(this.inputValues['cpf']) ? JSON.stringify(this.inputValues['cpf']) : '';
          if (this.requiredFields.includes('cpf')) return this.isValidCPF(cpf);
          else return true;

        case 'invited_by':
          return this.inputValues['invited_by'] != 'selecione';

        case 'discovery':
          return this.inputValues['discovery'] != 'selecione';

        case 'telephone':
          let minLen = 11;
          let fieldGroups = this.accessConfig.registerView.fieldGroups;
          fieldGroups.map((group) => {
            group.fields.map((field) => {
              if (field.name == 'telephone') {
                minLen = field.minlength ? field.minlength : minLen;
              }
              field.siblings?.map((sibling) => {
                if (sibling.name == 'telephone') {
                  minLen = sibling.minlength ? sibling.minlength : minLen;
                }
              });
            });
          });
          let telValue = formatPhoneNumber(this.inputValues['telephone']);
          return telValue.length >= minLen;

        default:
          return this.inputValues[inputName] && this.inputValues[inputName] != 'selecione';
      }

      function formatPhoneNumber(phoneNumber) {
        // Check if phoneNumber exists
        if (!phoneNumber) return '';

        // Mantenha o sinal "+" no início, se ele existir
        let plusSign = phoneNumber.startsWith('+') ? '+' : '';

        // Remova todos os caracteres que não são dígitos
        let digitsOnly = phoneNumber.replace(/\D/g, '');

        // Retorne o sinal "+" (se existir) seguido pelos dígitos
        return plusSign + digitsOnly;
      }
    },
    endsWithAny(suffixes, string) {
      for (let suffix of suffixes) {
        if (string.endsWith(suffix)) {
          return true;
        }
      }
      return false;
    },
    validDateBirth() {
      const date = new Date(this.dateBirth);
      return Boolean(+date) && date.getDate() === date.getDate(); //|| (!this.dateBirth);
    },
    isValidCPF(cpf) {
      cpf = cpf.replace(/[^\d]+/g, '');
      if (cpf == '') return false;
      // Elimina CPFs invalidos conhecidos
      if (
        cpf.length != 11 ||
        cpf == '00000000000' ||
        cpf == '11111111111' ||
        cpf == '22222222222' ||
        cpf == '33333333333' ||
        cpf == '44444444444' ||
        cpf == '55555555555' ||
        cpf == '66666666666' ||
        cpf == '77777777777' ||
        cpf == '88888888888' ||
        cpf == '99999999999'
      )
        return false;
      // Valida 1o digito
      let add = 0;
      let rev = 0;
      for (let i = 0; i < 9; i++) {
        add += parseInt(cpf.charAt(i)) * (10 - i);
      }
      rev = 11 - (add % 11);
      if (rev == 10 || rev == 11) rev = 0;
      if (rev != parseInt(cpf.charAt(9))) return false;
      // Valida 2o digito
      add = 0;
      for (let i = 0; i < 10; i++) {
        add += parseInt(cpf.charAt(i)) * (11 - i);
      }
      rev = 11 - (add % 11);
      if (rev == 10 || rev == 11) rev = 0;
      if (rev != parseInt(cpf.charAt(10))) return false;
      return true;
    },
    createOtherObject() {
      let other = {};
      this.allFields.map((field) => {
        if (!this.defaultFields.includes(field.name)) {
          other[field.name] = this.inputValues[field.name] ? this.inputValues[field.name] : '';
          if (other.password) delete other.password;
          try {
            if (typeof other[field.name] === 'array') other[field.name] = other[field.name].join(',');
          } catch (error) {}
        }
      });
      if (this.terms && this.terms.length > 0) {
        this.terms.map((term) => {
          other[term.name] = this.inputValues[term.name];
        });
      }
      return JSON.stringify(other);
    },
    submitDebounced() {
      if (this.debounce) return;
      this.debounce = true;
      this.checkBeforeRegister();
      setTimeout(() => {
        this.debounce = false;
      }, 3000);
    },
    async checkBeforeRegister() {
      // console.log('checkBeforeRegister');
      if (this.$store.state.template.showRecaptcha) {
        const captchaValidated = await this.validateRecaptcha();
        if (!captchaValidated) {
          // console.log('Captcha not validated');
          return;
        }
      }
      if (this.accessConfig.integrationUserLead && !this.userLeads) {
        this.shakeElement('email');
        this.shakeElement('code');
        return;
      }
      if (!this.fieldGroups.length || !this.fieldGroups[0]?.fields.length) return;
      if (this.categoryEnabled && this.inputValues['email'] && this.inputValues['name']) {
        switch (this.inputValues['category'].toLowerCase()) {
          case 'sim, sou médico':
            this.inputValues['password'] = this.inputValues['email'];
            this.showSpinner = true;
            api
              .get(`event/${this.$store.state.eventId}/userLead/code?value=${this.inputValues['crm_uf']}${this.inputValues['crm']?.padStart(7, '0')}`)
              .then((response) => {
                this.showSpinner = false;
                response.data.valid ? this.register() : alert('CRM inválido, verifique número e UF');
              })
              .catch((err) => {
                console.error(err);
                this.showSpinner = false;
                alert('Falha ao enviar');
              });
            break;
          case 'sim, sou farmacêutico':
            this.inputValues['password'] = this.inputValues['email'];
            this.showSpinner = true;
            api
              .get(`event/${this.$store.state.eventId}/userLead/code?value=${this.inputValues['crm_uf']}${this.inputValues['crm']?.padStart(7, '0')}`)
              .then((response) => {
                this.showSpinner = false;
                response.data.valid ? this.register() : alert('CRF inválido, verifique número e UF');
              })
              .catch((err) => {
                console.error(err);
                this.showSpinner = false;
                alert('Falha ao enviar');
              });
            break;
          case 'não, sou gestor público':
            this.inputValues['password'] = this.inputValues['email'];
            this.showSpinner = true;
            api
              .get(`event/${this.$store.state.eventId}/userLead/email?value=${this.inputValues['email'].toLowerCase()}`)
              .then((response) => {
                this.showSpinner = false;
                response.data.valid ? this.register() : alert('Por favor valide seu cadastro com seu consultor BI');
              })
              .catch((err) => {
                console.error(err);
                this.showSpinner = false;
                alert('Falha ao enviar');
              });
            break;
          case 'não, sou funcionário bi':
            this.requiredFields = ['email'];
            if (this.inputValues['email'].endsWith('@boehringer-ingelheim.com')) {
              this.inputValues['password'] = this.inputValues['email'];
              this.register();
            } else {
              alert('Email inválido, verifique o email informado');
              this.shakeElement('email');
            }
            break;
          default:
            this.shakeElement('category');
        }
      } else if (this.accessConfig.integration === 'code') {
        this.inputValues['password'] = this.inputValues['code'];
        if (this.accessConfig.integrationUserLead) {
          this.showSpinner = true;
          api
            .get(`event/${this.$store.state.eventId}/userLead/code?value=${this.inputValues['code']}`)
            .then((response) => {
              this.showSpinner = false;

              if (this.accessConfig.integrationUseDataFromLead) {
                if (response.data.userExists) {
                  this.fieldGroups.map((group) => {
                    group.fields.map((field) => {
                      if (field.name == 'name') field.enable = true;
                      if (field.name == 'email') field.enable = true;
                      if (field.name == 'email_confirm') field.enable = true;
                      if (field.name == 'code') field.lock = true;
                    });
                  });

                  this.inputValues['name'] = response.data.userExists.name;
                  let matchFixedDomain = this.accessConfig.integrationFixedDomain ? true : false;
                  let isFixedDomain = matchFixedDomain && response.data.userExists.email?.endsWith(this.accessConfig.integrationFixedDomain);

                  if (!this.fieldsAreValid() && !isFixedDomain) {
                    this.shakeElement('email');
                    setTimeout(() => {
                      alert(`Olá, ${this.inputValues['name']}, preencha e confirme email`);
                    }, 600);
                  }

                  if (isFixedDomain) {
                    if (!this.inputValues['email']) {
                      //this.inputValues['email'] = this.accessConfig.integrationFixedDomain;
                      //this.inputValues['email_confirm'] = this.accessConfig.integrationFixedDomain;
                    }

                    if (this.inputValues['email'].endsWith(this.accessConfig.integrationFixedDomain) && this.inputValues['email'] != this.accessConfig.integrationFixedDomain) {
                      response.data.valid ? this.register() : alert('Código inválido, verifique número e email');
                    } else {
                      this.shakeElement('email');
                      setTimeout(() => {
                        alert(`Olá, ${this.inputValues['name']}, preencha e confirme email ${this.accessConfig.integrationFixedDomain}`);
                      }, 600);
                    }
                  } else {
                    response.data.valid ? this.register() : alert('Código inválido, verifique número e email');
                  }
                } else {
                  response.data.valid ? this.register() : alert('Código inválido, verifique número');
                }

                // GENERAL EVENT
              } else {
                response.data.valid ? this.register() : alert('Código inválido, verifique número');
              }
            })
            .catch((err) => {
              console.error(err);
              this.showSpinner = false;
              alert('Falha ao enviar');
            });
        } else {
          this.fieldGroups.map((group) => {
            group.fields.map((field) => {
              if (field.name == 'name') field.enable = true;
              if (field.name == 'email') field.enable = true;
              if (field.name == 'email_confirm') field.enable = true;
              if (field.name == 'code') field.lock = false;
            });
          });
          this.register();
        }
      } else this.register();
    },
    async register() {
      // console.log('register');
      if (this.requiredTerms && this.requiredTerms.length > 0) {
        let checked = 0;
        this.requiredTerms.map((term) => {
          if (!this.inputValues[term.name]) this.shakeElement(term.name);
          else checked++;
        });
        if (checked < this.requiredTerms.length) {
          return;
        }
      }
      if (this.fieldsAreValid() && this.agree) {
        // console.log('fieldsAreValid');
        if (this.$store.state.user.id) {
          if (!this.inputValues['language_code']) this.inputValues['language_code'] = this.$store?.state?.user?.language || 'pt';

          let inputKeys = Object.keys(this.inputValues);
          let inputValues = Object.values(this.inputValues);
          let payload = { event_user_role_id: this.event_user_role_id };
          let other = {};
          let otherExists = false;
          if (inputKeys.length > 0) {
            for (let i = 0; i < inputKeys.length; i++) {
              if (this.defaultFields.includes(inputKeys[i])) {
                payload[inputKeys[i]] = inputValues[i];
              } else {
                otherExists = true;
                other[inputKeys[i].toLowerCase()] = inputValues[i] === undefined ? null : inputValues[i];
                if (inputValues[i] == '') delete other[inputKeys[i]];
              }
            }
            if (otherExists) {
              if (other.password) delete other.password;
              payload['other'] = JSON.stringify(other);
            }
            if (payload.password) payload.password = await encrypt(payload.password.trim());
            if (payload.password_confirm) delete payload.password_confirm;
            api
              .put(`event/${this.$store.state.eventId}/user/${this.$store.state.user.id}`, payload)
              .then((response) => {
                this.debounce = false;
                // console.log('put user response', response);
                try {
                  const data = JSON.parse(response.config.data);
                  const nickname = data.nickname;
                  const name = data.name;
                  const email = data.email;

                  this.$store.commit('setUserName', name);
                  this.$store.commit('setUserEmail', email);
                  this.$store.commit('setUserNickname', nickname);
                } catch (error) {
                  console.error('error parsing user data', error);
                }

                this.$modal.show('dialog', {
                  title: '',
                  text: this.accessConfig.alerts ? (this.accessConfig.alerts.updated ? this.accessConfig.alerts.updated : 'Cadastro atualizado.') : 'Cadastro atualizado.',
                  buttons: [
                    {
                      title: 'Ok',
                      handler: () => {
                        this.$modal.hide('dialog');
                        this.$router
                          .push({
                            name: this.accessConfig.firstPageAlt ? this.accessConfig.firstPageAlt : this.accessConfig.firstPage,
                            params: this.accessConfig.firstPageParamsAlt ? this.accessConfig.firstPageParamsAlt : this.accessConfig.firstPageParams,
                          })
                          .catch((err) => {
                            console.error('navigation error', err);
                            alert(
                              this.accessConfig.alerts
                                ? this.accessConfig.alerts.updatedRedirectError
                                  ? this.accessConfig.alerts.updatedRedirectError
                                  : 'Seu cadastro foi atualizado, mas encontramos um erro no momento de redirecioná-lo.'
                                : 'Seu cadastro foi atualizado, mas encontramos um erro no momento de redirecioná-lo.',
                            );
                          });
                        this.$emit('close');
                      },
                    },
                  ],
                });
              })
              .catch((err, data) => {
                this.debounce = false;
                console.error('error', err.response, data);
                if (err.response.data.error) {
                  if (err.response.data.error.includes('Email already in database') || err.response.data.error.includes('Email already used.') || err.response.data.error.includes('Code already in database')) {
                    this.$modal.show('dialog', {
                      title: '',
                      text: this.accessConfig.alerts
                        ? this.accessConfig.alerts.alreadyRegistered
                          ? this.accessConfig.alerts.alreadyRegistered
                          : 'Que boa notícia, você já está cadastrado nas nossas bases. Siga para a tela de login e utilize sua senha cadastrada. Se não conhece ou não lembra da senha, siga o processo "Esqueci minha senha".'
                        : 'Que boa notícia, você já está cadastrado nas nossas bases. Siga para a tela de login e utilize sua senha cadastrada. Se não conhece ou não lembra da senha, siga o processo "Esqueci minha senha".',
                      buttons: [
                        {
                          title: 'Ok',
                          handler: () => {
                            this.$modal.hide('dialog');
                          },
                        },
                      ],
                    });
                    // alert(
                    //   this.accessConfig.alerts
                    //     ? this.accessConfig.alerts.alreadyRegistered
                    //       ? this.accessConfig.alerts.alreadyRegistered
                    //       : 'Que boa notícia, você já está cadastrado nas nossas bases. Siga para a tela de login e utilize sua senha cadastrada. Se não conhece ou não lembra da senha, siga o processo "Esqueci minha senha".'
                    //     : 'Que boa notícia, você já está cadastrado nas nossas bases. Siga para a tela de login e utilize sua senha cadastrada. Se não conhece ou não lembra da senha, siga o processo "Esqueci minha senha".',
                    // );
                  } else {
                    this.$modal.show('dialog', {
                      title: '',
                      text: this.accessConfig.alerts
                        ? this.accessConfig.alerts.registerError
                          ? this.accessConfig.alerts.registerError
                          : 'Erro no momento do cadastro, por favor, valide seus dados.'
                        : 'Erro no momento do cadastro, por favor, valide seus dados.',
                      buttons: [
                        {
                          title: 'Ok',
                          handler: () => {
                            this.$modal.hide('dialog');
                          },
                        },
                      ],
                    });
                    // alert(this.accessConfig.alerts ? (this.accessConfig.alerts.registerError ? this.accessConfig.alerts.registerError : 'Erro no momento do cadastro, por favor, valide seus dados.') : 'Erro no momento do cadastro, por favor, valide seus dados.');
                  }
                } else {
                  this.$modal.show('dialog', {
                    title: '',
                    text: this.accessConfig.alerts
                      ? this.accessConfig.alerts.registerError
                        ? this.accessConfig.alerts.registerError
                        : 'Erro no momento do cadastro, por favor, valide seus dados.'
                      : 'Erro no momento do cadastro, por favor, valide seus dados.',
                    buttons: [
                      {
                        title: 'Ok',
                        handler: () => {
                          this.$modal.hide('dialog');
                        },
                      },
                    ],
                  });
                  // alert(this.accessConfig.alerts ? (this.accessConfig.alerts.registerError ? this.accessConfig.alerts.registerError : 'Erro no momento do cadastro, por favor, valide seus dados.') : 'Erro no momento do cadastro, por favor, valide seus dados.');
                }
              });
          } else {
            this.$router
              .push({
                name: this.accessConfig.firstPageAlt ? this.accessConfig.firstPageAlt : this.accessConfig.firstPage,
                params: this.accessConfig.firstPageParamsAlt ? this.accessConfig.firstPageParamsAlt : this.accessConfig.firstPageParams,
              })
              .catch((err) => {
                console.error('navigation error', err);
                alert(
                  this.accessConfig.alerts
                    ? this.accessConfig.alerts.registeredRedirectError
                      ? this.accessConfig.alerts.registeredRedirectError
                      : 'Seu cadastro foi realizado, mas encontramos um erro no momento de redirecioná-lo.'
                    : 'Seu cadastro foi realizado, mas encontramos um erro no momento de redirecioná-lo.',
                );
              });
            this.$emit('close');
          }
        } else {
          // UNICOCHECK
          if (this.accessConfig.integration === 'UNICOCHECK') {
            //Open Camera
            this.showButtonSpinner = true;
            this.unicoCheck = true;
            return;
          }

          // defaultPassword
          if (this.accessConfig.passwordUsed && this.accessConfig.defaultPassword) {
            this.inputValues['password'] = this.accessConfig.defaultPassword;
            this.requiredFields.push('password');
          }

          api
            .post(`event/${this.$store.state.eventId}/user`, {
              event_user_role_id: this.event_user_role_id,
              email: this.inputValues['email'] ? this.inputValues['email'].toLowerCase().trim() : null,
              password: this.requiredFields.includes('password') && this.inputValues['password'] ? await encrypt(this.inputValues['password'].trim()) : null,
              name: this.inputValues['name'],
              nickname: this.inputValues['nickname'],
              about_me: this.inputValues['about_me'],
              //image :
              gender: this.inputValues['gender'],
              date_of_birth: this.validDateBirth() ? new Date(this.inputValues['date_of_birth']) : null,
              telephone: this.inputValues['telephone'],
              cep: this.inputValues['cep'],
              street: this.inputValues['street'],
              number: this.inputValues['number'],
              complement: this.inputValues['complement'],
              neighborhood: this.inputValues['neighborhood'],
              city_id: this.inputValues['city_id'],
              state_code: this.inputValues['state_code'],
              country_code: this.inputValues['country_code'],
              language_code: this.inputValues['language_code'] || this.$store?.state?.user?.language || 'pt',
              timezone: this.inputValues['timezone'],
              opt_in: this.inputValues['opt_in'],
              code: this.inputValues['code'],
              cpf: this.inputValues['cpf'],
              company: this.inputValues['company'],
              role: this.inputValues['role'],
              other: this.createOtherObject(),
              login: false,
              integration: this.accessConfig.integration ? this.accessConfig.integration : '',
              valid: this.accessConfig.valid ? this.accessConfig.valid : false,
              sendEmail: !this.accessConfig.sendEmail ? this.accessConfig.sendEmail : true,
              sendWhatsapp: !this.accessConfig.sendWhatsapp ? this.accessConfig.sendWhatsapp : true,
              login: this.autoLogin ? true : false,
              exclusiveRegister: this.accessConfig.exclusiveRegister ? this.accessConfig.exclusiveRegister : false,
            })
            .then((response) => {
              this.debounce = false;
              if (this.autoLogin) {
                //console.log('AUTOLOGIN:',response);
                this.$store.commit({
                  type: 'setUser',
                  userData: response.data,
                });
                redirect.redirectAfterLogin(response, false, null, this.$modal, true);
              } else {
                this.$modal.show('dialog', {
                  title: '',
                  text: this.accessConfig.alerts
                    ? this.accessConfig.alerts.registered
                      ? this.accessConfig.alerts.registered
                      : 'Cadastro realizado. Por favor, realize seu login com as informações inseridas.'
                    : 'Cadastro realizado. Por favor, realize seu login com as informações inseridas.',
                  buttons: [
                    {
                      title: 'Ok',
                      handler: () => {
                        if (this.$store.state.template.useUnifiedLoginRegister) {
                          this.$emit('goLogin');
                        } else {
                          this.$router
                            .push({
                              name: 'Login',
                            })
                            .catch((err) => {
                              console.error('navigation error', err);
                              alert(
                                this.accessConfig.alerts
                                  ? this.accessConfig.alerts.registeredRedirectError
                                    ? this.accessConfig.alerts.registeredRedirectError
                                    : 'Seu cadastro foi realizado, mas encontramos um erro no momento de redirecioná-lo.'
                                  : 'Seu cadastro foi realizado, mas encontramos um erro no momento de redirecioná-lo.',
                              );
                            });
                        }
                        this.$modal.hide('dialog');
                      },
                    },
                  ],
                });
              }
            })
            .catch((err, data) => {
              this.debounce = false;
              console.error('error', { err });
              if (err.response?.data?.error) {
                if (err.response.data.error.includes('Email already in database') || err.response.data.error.includes('Email already used.') || err.response.data.error.includes('Code already in database')) {
                  this.$modal.show('dialog', {
                    title: '',
                    text: this.accessConfig.alerts
                      ? this.accessConfig.alerts.alreadyRegistered
                        ? this.accessConfig.alerts.alreadyRegistered
                        : 'Que boa notícia, você já está cadastrado nas nossas bases. Siga para a tela de login e utilize sua senha cadastrada.'
                      : 'Que boa notícia, você já está cadastrado nas nossas bases. Siga para a tela de login e utilize sua senha cadastrada.',
                    buttons: [
                      {
                        title: 'Ok',
                        handler: () => {
                          this.$modal.hide('dialog');
                          if (!this.accessConfig.exclusiveRegisterNoRedirectLogin) {
                            this.$router
                              .push({
                                name: 'Login',
                              })
                              .catch((err) => {
                                console.error('navigation error', err);
                                alert(
                                  this.accessConfig.alerts
                                    ? this.accessConfig.alerts.registeredRedirectError
                                      ? this.accessConfig.alerts.registeredRedirectError
                                      : 'Seu cadastro foi realizado, mas encontramos um erro no momento de redirecioná-lo.'
                                    : 'Seu cadastro foi realizado, mas encontramos um erro no momento de redirecioná-lo.',
                                );
                              });
                            this.$emit('close');
                          }
                        },
                      },
                    ],
                  });
                } else {
                  this.$modal.show('dialog', {
                    title: '',
                    text: this.accessConfig.alerts
                      ? this.accessConfig.alerts.registerError
                        ? this.accessConfig.alerts.registerError
                        : 'Erro no momento do cadastro, por favor, valide seus dados.'
                      : 'Erro no momento do cadastro, por favor, valide seus dados.',
                    buttons: [
                      {
                        title: 'Ok',
                        handler: () => {
                          this.$modal.hide('dialog');
                        },
                      },
                    ],
                  });
                }
              } else {
                this.$modal.show('dialog', {
                  title: '',
                  text: this.accessConfig.alerts
                    ? this.accessConfig.alerts.registerError
                      ? this.accessConfig.alerts.registerError
                      : 'Erro no momento do cadastro, por favor, valide seus dados.'
                    : 'Erro no momento do cadastro, por favor, valide seus dados.',
                  buttons: [
                    {
                      title: 'Ok',
                      handler: () => {
                        this.$modal.hide('dialog');
                      },
                    },
                  ],
                });
              }
            });
        }
      } else {
        // console.log('Invalid');
        if (!this.agree) {
          this.shakeAgree = true;
          setTimeout(() => {
            this.shakeAgree = false;
          }, 500);
        }
      }
    },
    shakeElement(id) {
      let el = document.getElementById(id);
      if (el !== null) {
        el.style.borderBottom = '2px solid red';
        el.classList.add('shakeAnimation');
        setTimeout(() => {
          el.classList.remove('shakeAnimation');
        }, 500);
        setTimeout(() => {
          el.style.borderBottom = 'unset';
        }, 5000);
      }
    },
    keypressHandler(event) {
      this.updateInputs();
      if (event.keyCode == 13) this.submitDebounced();
    },
    randomKey() {
      return this.$RNG.randomKey();
    },
    inputChanged(event, initiator) {
      if (initiator.case === 'text-transform: uppercase') {
        // Transform input value to uppercase
        this.inputValues[initiator.name] = event.target.value.toUpperCase();
      } else {
        // If no transformation needed, save the input value directly
        if (event.target) this.inputValues[initiator.name] = event.target.value;
        else this.inputValues[initiator.name] = event;
      }
      if (initiator.type === 'select' && initiator.matchLeadsFieldName) return;
      this.fieldGroups.map((group) => {
        group.fields.map((field) => {
          if ((field.matchLeadsFieldName || field.queryType) && field.name != initiator.name) {
            // this.inputValues[field.name] = '';
            // field.lock = false;
          }
          if (field.siblings) {
            field.siblings.map((sibling) => {
              if (sibling.matchLeadsFieldName && sibling.name != initiator.name) {
                // this.inputValues[sibling.name] = '';
                //sibling.lock = false;
              }
            });
          }
        });
      });
    },
    handleAutocomplete(event, initiator, ranOnce) {
      // console.log('handleAutocomplete this.inputValues[initiator.name]', this.inputValues[initiator.name]);
      if (!initiator.queryType) return;
      // console.log('AUTOCOMPLETE', { event }, { initiator }, { ranOnce });
      let value = this.inputValues[initiator.name];
      if (initiator.queryType == 'email') {
        value = this.inputValues[initiator.name].toLowerCase();
      }
      api
        .get(`event/${this.$store.state.eventId}/userLead/${initiator.queryType}?value=${value}`)
        .then((response) => {
          if (response.data?.userExists) {
            this.userLeads = response.data.userExists;
            try {
              this.userLeads.other = JSON.parse(this.userLeads.other);
              Object.keys(this.userLeads.other).map((key) => {
                this.userLeads[key] = this.userLeads.other[key];
              });
            } catch (error) {
              userLead.other = '{}';
            }

            this.fieldGroups.map((group) => {
              group.fields.map((field) => {
                if (field.matchLeadsFieldName && field.fromInitiator == initiator.name) {
                  this.inputValues[field.name] = this.userLeads[field.matchLeadsFieldName];
                  field.lock = true;
                }
                if (field.siblings) {
                  field.siblings.map((sibling) => {
                    if (sibling.matchLeadsFieldName && sibling.fromInitiator == initiator.name) {
                      this.inputValues[sibling.name] = this.userLeads[sibling.matchLeadsFieldName];
                      sibling.lock = true;
                    }
                  });
                }
                return field;
              });
              return group;
            });
            if (!ranOnce) {
              this.$nextTick(() => {
                this.fieldGroups.map((group) => {
                  group.fields.map((field) => {
                    if (field.queryType) {
                      this.handleAutocomplete({ target: field }, field, true);
                    }
                    if (field.siblings) {
                      field.siblings.map((sibling) => {
                        if (sibling.queryType) {
                          this.handleAutocomplete({ target: sibling }, sibling, true);
                        }
                      });
                    }
                  });
                });
                this.sectionKey = this.$RNG.randomKey();
              });
            }
          } else {
            this.userLeads = null;
          }
          this.sectionKey = this.$RNG.randomKey();
        })
        .catch((err) => {
          console.error(err);
          //alert('Falha ao ler Leads');
          //Limpar userLead
          this.userLeads = null;
        });
    },
    showOSK(fieldName) {
      // OSK ONLY WORKS ON GLOBAL INTELLIGENCE EVENT
      if (window.innerWidth < 1024 || !this.$store.state.template.accessConfig.useOSK) return;

      if (fieldName == 'telephone') {
        this.oskLayout = 'default_compact_numbers';
        let telInput = this.$refs[fieldName][0].$el.querySelector('input');
        this.selectedInput = telInput;
      } else if (fieldName == 'cpf') {
        this.oskLayout = 'default_compact_numbers';
        this.selectedInput = this.$refs[fieldName][0];
      } else {
        this.oskLayout = 'default_compact';
        this.selectedInput = this.$refs[fieldName][0];
      }
      this.showOnScreenSKeyboard = true;
    },
    hideOSK() {
      this.showOnScreenSKeyboard = false;
    },
    oskDragStopped(top, left) {
      this.oskKey = this.$RNG.randomKey();
      this.oskStoredTop = top;
      this.oskStoredLeft = left;
    },
    async validateRecaptcha() {
      return new Promise((resolve, reject) => {
        const that = this;
        grecaptcha.ready(function () {
          grecaptcha.execute('6LdQjUAhAAAAAIMxWRWaOQufCFxLtyakeAtKiaEr', { action: 'homepage' }).then((token) => {
            // console.log('startRecaptcha TOKEN', token);
            api
              //.get(`/siteverify?secret=6LdQjUAhAAAAAIcujIhzn7PfWH1midaY2hbHv1Pv&response=${token}`)
              .get(`/captcha?captcha=${token}`)
              .then((response) => {
                // console.log('check reCaptcha, isHuman:', response.data.isHuman, response);
                if (response.data && response.data.isHuman === false) {
                  that.$modal.show('dialog', {
                    title: 'Recaptcha',
                    text: '🤖',
                    buttons: [
                      {
                        title: 'Ok',
                        handler: () => {
                          that.$modal.hide('dialog');
                          resolve(false);
                        },
                      },
                    ],
                  });
                } else resolve(true);
              })
              .catch((err) => {
                resolve(true);
              });
          });
        });
      });

      // (optional) Wait until recaptcha has been loaded.
      // await this.$recaptchaLoaded();
      // const recaptcha = this.$recaptchaInstance;
      // console.log('recaptcha', { recaptcha });

      // const token = await this.$recaptcha('homepage');
      // console.log('validateRecaptcha TOKEN', token);

      // apiTest.get(`captcha?captcha=${token}`).then(response => {
      //   console.log('check reCaptcha, isHuman:', response.data.isHuman, response);
      // });
    },
    conformedSearchableSelectOptions(options) {
      const conformed = options.map((option) => {
        return {
          value: option,
          text: option,
        };
      });
      return conformed;
    },
    async validinfo(id, cpf) {
      const ret = await new Promise((resolve, reject) =>
        api
          .post(`event/${this.$store.state.eventId}/unico/valid`, {
            unico_id: id,
            code: cpf,
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            try {
              //console.log('A:',error);
              //console.log('A1:',error.response.data);
              if (!JSON.stringify(error.response.data).includes('Waiting process from Unico check.')) {
                //console.log('B',error);
                reject(error);
              }
            } catch (err) {
              reject(err);
            }

            resolve('waiting');
          }),
      );
      //console.log('RETURN=',ret);
      return ret;
    },
    async getImage(data) {
      this.processingUnico = true;
      //console.log('Voltou!!!');
      //console.log(data);
      // this.unicoCheck = false;
      // this.showButtonSpinner = false;

      api
        .post(`event/${this.$store.state.eventId}/unico/create`, {
          event_user_role_id: this.event_user_role_id,
          email: this.inputValues['email'] ? this.inputValues['email'].toLowerCase().trim() : null,
          password: this.requiredFields.includes('password') && this.inputValues['password'] ? await encrypt(this.inputValues['password'].trim()) : null,
          name: this.inputValues['name'],
          nickname: this.inputValues['nickname'],
          about_me: this.inputValues['about_me'],
          image: data.base64 ? 'data:image/png;base64,' + data.base64 : null,
          encrypted: data.encrypted,
          gender: this.inputValues['gender'],
          date_of_birth: this.validDateBirth() ? new Date(this.inputValues['date_of_birth']) : null,
          telephone: this.inputValues['telephone'],
          cep: this.inputValues['cep'],
          street: this.inputValues['street'],
          number: this.inputValues['number'],
          complement: this.inputValues['complement'],
          neighborhood: this.inputValues['neighborhood'],
          city_id: this.inputValues['city_id'],
          state_code: this.inputValues['state_code'],
          country_code: this.inputValues['country_code'],
          language_code: this.inputValues['language_code'] || this.$store?.state?.user?.language || 'pt',
          timezone: this.inputValues['timezone'],
          opt_in: this.inputValues['opt_in'],
          code: this.inputValues['code'],
          cpf: this.inputValues['cpf'],
          company: this.inputValues['company'],
          role: this.inputValues['role'],
          other: this.createOtherObject(),
          integration: this.accessConfig.integration ? this.accessConfig.integration : '',
          valid: this.accessConfig.valid ? this.accessConfig.valid : false,
          sendEmail: !this.accessConfig.sendEmail ? this.accessConfig.sendEmail : true,
          sendWhatsapp: !this.accessConfig.sendWhatsapp ? this.accessConfig.sendWhatsapp : true,
          login: this.autoLogin ? true : false,
          exclusiveRegister: this.accessConfig.exclusiveRegister ? this.accessConfig.exclusiveRegister : false,
          //version: '1.0.1',
        })
        .then(async (response) => {
          let retry = 0;
          do {
            try {
              const ret = await this.validinfo(response.data.unico_id, this.inputValues['cpf']);
              if (ret == 'waiting') {
                await new Promise((resolve) => setTimeout(resolve, 2000));
                retry++;
              } else retry = 70;
            } catch (err) {
              //await new Promise(resolve => setTimeout(resolve, 2000));
              //retry++;
              //console.log('!AQUI', err)
              throw err;
            }
          } while (retry < 60);
          if (retry < 70) {
            throw 'Error: Max retries attempt.';
          }
          if (this.autoLogin) {
            api
              .post(`event/${this.$store.state.eventId}/unico/login`, {
                code: this.inputValues['cpf'],
                password: await encrypt(this.inputValues['cpf']),
              })
              .then((response) => {
                this.$store.commit({
                  type: 'setUser',
                  userData: response.data,
                });
                redirect.redirectAfterLogin(response, false, null, this.$modal, true);
              })
              .catch((error) => {
                console.error(error);
                this.$modal.show('dialog', {
                  title: '',
                  text: this.accessConfig.alerts
                    ? this.accessConfig.alerts.registered
                      ? this.accessConfig.alerts.registered
                      : 'Cadastro realizado. Por favor, realize seu login com as informações inseridas.'
                    : 'Cadastro realizado. Por favor, realize seu login com as informações inseridas.',
                  buttons: [
                    {
                      title: 'Ok',
                      handler: () => {
                        if (this.$store.state.template.useUnifiedLoginRegister) {
                          this.$emit('goLogin');
                        } else {
                          this.$router
                            .push({
                              name: 'Login',
                            })
                            .catch((err) => {
                              console.error('navigation error', err);
                              alert(
                                this.accessConfig.alerts
                                  ? this.accessConfig.alerts.registeredRedirectError
                                    ? this.accessConfig.alerts.registeredRedirectError
                                    : 'Seu cadastro foi realizado, mas encontramos um erro no momento de redirecioná-lo.'
                                  : 'Seu cadastro foi realizado, mas encontramos um erro no momento de redirecioná-lo.',
                              );
                            });
                        }
                        this.$modal.hide('dialog');
                      },
                    },
                  ],
                });
              });
          } else {
            this.$modal.show('dialog', {
              title: '',
              text: this.accessConfig.alerts
                ? this.accessConfig.alerts.registered
                  ? this.accessConfig.alerts.registered
                  : 'Cadastro realizado. Por favor, realize seu login com as informações inseridas.'
                : 'Cadastro realizado. Por favor, realize seu login com as informações inseridas.',
              buttons: [
                {
                  title: 'Ok',
                  handler: () => {
                    if (this.$store.state.template.useUnifiedLoginRegister) {
                      this.$emit('goLogin');
                    } else {
                      this.$router
                        .push({
                          name: 'Login',
                        })
                        .catch((err) => {
                          console.error('navigation error', err);
                          alert(
                            this.accessConfig.alerts
                              ? this.accessConfig.alerts.registeredRedirectError
                                ? this.accessConfig.alerts.registeredRedirectError
                                : 'Seu cadastro foi realizado, mas encontramos um erro no momento de redirecioná-lo.'
                              : 'Seu cadastro foi realizado, mas encontramos um erro no momento de redirecioná-lo.',
                          );
                        });
                    }
                    this.$modal.hide('dialog');
                  },
                },
              ],
            });
          }

          this.unicoCheck = false;
          this.showButtonSpinner = false;
          this.processingUnico = false;
        })
        .catch((err, data) => {
          console.error('error', { err });
          if (err.response?.data?.error) {
            if (
              typeof err.response.data.error === 'string' &&
              (err.response.data.error.includes('Email already in database') || err.response.data.error.includes('Email already used.') || err.response.data.error.includes('Code already in database'))
            ) {
              this.$modal.show('dialog', {
                title: '',
                text: this.accessConfig.alerts
                  ? this.accessConfig.alerts.alreadyRegistered
                    ? this.accessConfig.alerts.alreadyRegistered
                    : 'Que boa notícia, você já está cadastrado nas nossas bases. Siga para a tela de login e utilize sua senha cadastrada.'
                  : 'Que boa notícia, você já está cadastrado nas nossas bases. Siga para a tela de login e utilize sua senha cadastrada.',
                buttons: [
                  {
                    title: 'Ok',
                    handler: () => {
                      this.$modal.hide('dialog');
                      if (!this.accessConfig.exclusiveRegisterNoRedirectLogin) {
                        this.$router
                          .push({
                            name: 'Login',
                          })
                          .catch((err) => {
                            console.error('navigation error', err);
                            alert(
                              this.accessConfig.alerts
                                ? this.accessConfig.alerts.registeredRedirectError
                                  ? this.accessConfig.alerts.registeredRedirectError
                                  : 'Seu cadastro foi realizado, mas encontramos um erro no momento de redirecioná-lo.'
                                : 'Seu cadastro foi realizado, mas encontramos um erro no momento de redirecioná-lo.',
                            );
                          });
                        this.$emit('close');
                      }
                    },
                  },
                ],
              });
            } else if (err.response.data.error.Error?.Description) {
              this.$modal.show('dialog', {
                title: err.response.data.error.Error.Description,
                text: `Por favor, tente realizar novamente o processo ou entre em contato com o suporte.`,
                buttons: [
                  {
                    title: 'Ok',
                    handler: () => {
                      this.$modal.hide('dialog');
                    },
                  },
                ],
              });
            } else if (err.response.data.error.error) {
              this.$modal.show('dialog', {
                title: err.response.data.error.error,
                text: `Por favor, tente realizar novamente o processo ou entre em contato com o suporte.`,
                buttons: [
                  {
                    title: 'Ok',
                    handler: () => {
                      this.$modal.hide('dialog');
                    },
                  },
                ],
              });
            } else {
              this.$modal.show('dialog', {
                title: '',
                text: this.accessConfig.alerts
                  ? this.accessConfig.alerts.registerError
                    ? this.accessConfig.alerts.registerError
                    : 'Erro no momento do cadastro, por favor, valide seus dados.'
                  : 'Erro no momento do cadastro, por favor, valide seus dados.',
                buttons: [
                  {
                    title: 'Ok',
                    handler: () => {
                      this.$modal.hide('dialog');
                    },
                  },
                ],
              });
            }
          } else {
            this.$modal.show('dialog', {
              title: '',
              text: this.accessConfig.alerts
                ? this.accessConfig.alerts.registerError
                  ? this.accessConfig.alerts.registerError
                  : 'Erro no momento do cadastro, por favor, valide seus dados.'
                : 'Erro no momento do cadastro, por favor, valide seus dados.',
              buttons: [
                {
                  title: 'Ok',
                  handler: () => {
                    this.$modal.hide('dialog');
                  },
                },
              ],
            });
          }

          this.unicoCheck = false;
          this.showButtonSpinner = false;
          this.processingUnico = false;
        });
    },
    treatError(error) {
      // console.log('Pegou a zica!!!');
      //console.log(error);
      this.showButtonSpinner = false;
      this.unicoCheck = false;
      this.$modal.show('dialog', {
        title: 'Falha no processo de captura',
        text: 'Por favor, tente realizar novamente o processo de captura.',
        buttons: [
          {
            title: 'Ok',
            handler: () => {
              this.$modal.hide('dialog');
            },
          },
        ],
      });
    },
  },
  beforeMount() {
    try {
      this.getAccessLevelsData();
    } catch (err) {
      console.error(err);
    }
    this.sectionKey = this.randomKey();
    this.fieldsKey = this.randomKey();
    // console.log(this.inputValues);
    let fieldGroups = this.accessConfig.registerView.fieldGroups;
    fieldGroups.map((group) => {
      group.fields.map((field) => {
        if (field.enable && field.required && !field.conditional) this.requiredFields.push(field.name);
        field.siblings?.map((sibling) => {
          if (sibling.enable && sibling.required && !sibling.conditional) this.requiredFields.push(sibling.name);
        });
      });
    });

    if (this.accessConfig.registerView.terms) {
      this.terms = this.accessConfig.registerView.terms.length ? this.accessConfig.registerView.terms : [];
      this.terms.map((term) => {
        if (term.required) this.requiredFields.push(term.name);
        if (term.default) this.inputValues[term.name] = term.default;
      });
    }

    if (this.requiredFields.includes('category')) this.categoryEnabled = true;

    // DISABLE FIELDS FOR accessConfig.integrationUseDataFromLead
    if (this.accessConfig.integrationUseDataFromLead) {
      this.fieldGroups.map((group) => {
        group.fields.map((field) => {
          if (field.name == 'name') field.enable = false;
          if (field.name == 'email') field.enable = false;
          if (field.name == 'email_confirm') field.enable = false;
          if (field.name == 'code') field.lock = false;
        });
      });
    }

    this.agree = this.accessConfig.registerView.agreeDefaultValue ? this.accessConfig.registerView.agreeDefaultValue : false;
  },
  mounted() {
    //this.email = this.$store.state.username;
    this.inputValues['password'] = '';
    this.collectDefaultValues();
    this.$nextTick(() => {
      if (this.$store.state.user.id) {
        // console.log('User ID=', this.user_id);
        this.collectValues();
      }
    });
  },
  updated() {
    this.assignAccessLevel();
    this.evaluateRequiredFields();
  },
};
</script>

<style lang="scss">
.unicotest-processing-checkCamera {
  position: relative;
  color: var(--labelColor);
  z-index: 1;
  border-radius: 5px;
  padding: 30px 20px;
  border: 1px solid var(--labelColor);

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.unicotest-frame-checkCamera {
  position: relative;
  width: 100%;
  height: 100dvh;
  z-index: 1;

  display: flex;
  justify-content: center;
  align-items: center;
}
.send-btn-disabled {
  filter: brightness(0.5);
  cursor: not-allowed;
}
</style>
